import React, { Fragment, useContext, useEffect } from "react";

import { Notes } from "../components/Notes";
import { Form } from "../components/Form";
import { FirebaseContext } from "../Context/Firebase/firebaseContext";
import { Loader } from "../components/Loader";

export const Home = (props) => {
    const {loading, notes, fetchNotes, removeNote} = useContext(FirebaseContext)

    useEffect(() => {
        fetchNotes()
        // eslint-disable-next-line
    },[])

    return (  
    <Fragment>
        <Form />

        <br />

        {loading
        ? <Loader />
        : <Notes notes={notes} onRemove={removeNote}/>}

    </Fragment>
    )
}